const headers = [{
    text: "Código do Contrato",
    align: "left",
    sortable: true,
    value: "contractCode"
  },
  {
    text: "Empresa",
    align: "center",
    value: "company",
    sortable: false
  },
  {
    text: "Cliente",
    align: "center",
    value: "client",
    sortable: false
  },
  {
    text: "Situação",
    align: "center",
    value: "status",
    sortable: false
  },
  {
    text: "Ações",
    align: "center",
    value: "name",
    sortable: false
  }
]
const budgetHeaders = [{
    text: "#",
    align: "left",
    sortable: true,
    value: "code"
  },
  {
    text: "Empresa",
    align: "center",
    value: "company"
  },
  {
    text: "Tipo do Orçamento",
    align: "center",
    value: "tradingFloor"
  },
  {
    text: "Processo",
    align: "center",
    value: "process"
  },
  {
    text: "Cliente",
    align: "center",
    value: "client"
  },
  {
    text: "Data do Pregão",
    align: "center",
    value: "dateOfTheTradingFloor"
  }
]
const consumablesHeader = [{
    text: "Especificação / Descrição",
    align: "center",
    value: "description"
  },
  {
    text: "Unidade de Medida",
    align: "center",
    value: "unity"
  },
  {
    text: "Quantidade Prevista",
    align: "center",
    value: "quantity"
  },
  {
    text: "Valor Unitário",
    align: "center",
    value: "unitaryValue"
  },
 /*  {
    text: "Sub-Total",
    align: "center",
    sortable: false
  }, */
  {
    text: "Vida Útil (mês)",
    align: "center",
    value: "lifetime"
  },

  /*  {
     text: "Valor Mensal",
     align: "center",
     value: "monthlyValue"
   }, */
  {
    text: "Quantidade Aprovada",
    align: "center",
    sortable: false
  },
  {
    text: "Frequência de Envio (mês)",
    align: "center",
    value: "shippingFrequency"
  },
  {
    text: "Envio Automático",
    align: "center",
    value: "automaticShipping",
  }
]
const equipmentsHeaders = [{
    text: "Especificação / Descrição",
    align: "center",
    value: "description"
  },
  {
    text: "Marca / Modelo",
    align: "center",
    value: "stamp"
  },
  {
    text: "Quantidade Prevista",
    align: "center",
    value: "quantity"
  },
  {
    text: "Valor Unitário",
    align: "center",
    value: "unitaryValue"
  },
/*   {
    text: "Sub-Total",
    align: "center",
    sortable: false
  }, */
  {
    text: "Vida Útil (%)",
    align: "center",
    value: "lifetime"
  },
  /*  {
     text: "Valor Mensal",
     align: "center",
     value: "monthlyValue"
   }, */
  {
    text: "Quantidade Aprovada",
    align: "center",
    sortable: false
  },
  {
    text: "Frequência de Envio (mês)",
    align: "center",
    value: "shippingFrequency"
  },
  {
    text: "Envio Automático",
    align: "center",
    value: "automaticShipping",
  }
]
const utencilHeaders = [{
    text: "Descrição / Especificação",
    align: "left",
    sortable: true,
    value: "description"
  },

  {
    text: "Unidade",
    align: "center",
    value: "unity"
  },

  {
    text: "Quantidade Prevista",
    align: "center",
    value: "quantity"
  },
  {
    text: "Valor Unitário",
    align: "center",
    value: "unitaryValue"
  },
 /*  {
    text: "Sub-Total",
    align: "center",
    sortable: false
  }, */
  {
    text: "Vida Útil (mês)",
    align: "center",
    value: "lifetime"
  },
  /*   {
      text: "Valor Mensal",
      align: "center",
      value: "monthlyValue"
    }, */
  {
    text: "Quantidade Aprovada",
    align: "center",
    value: "name",
    sortable: false
  },
  {
    text: "Frequência de Envio (mês)",
    align: "center",
    value: "shippingFrequency"
  },
  {
    text: "Envio Automático",
    align: "center",
    value: "automaticShipping",
  }
]
const uniformsAndEPIsHeaders = [{
    text: "Descrição / Especificação",
    align: "left",
    sortable: true,
    value: "description"
  },

  {
    text: "Unidade",
    align: "center",
    value: "unity"
  },
  {
    text: "Quantidade Prevista",
    align: "center",
    value: "quantity"
  },
  {
    text: "Valor Unitário",
    align: "center",
    value: "unitaryValue"
  },
/*   {
    text: "Sub-Total",
    align: "center",
    sortable: false
  }, */
  {
    text: "Vida Útil (mês)",
    align: "center",
    value: "lifetime"
  },
 
  /*  {
     text: "Valor Mensal",
     align: "center",
     value: "monthlyValue"
   }, */
  {
    text: "Quantidade Aprovada",
    align: "center",
    value: "name",
    sortable: false
  },
  {
    text: "Frequência de Envio (mês)",
    align: "center",
    value: "shippingFrequency"
  },
  {
    text: "Envio Automático",
    align: "center",
    value: "automaticShipping",
  }
];
const supervisorHeaders = [{
    text: "Nome",
    align: "center",
    sortable: true,
    value: "name"

  },
  {
    text: "Função",
    align: "center",
    sortable: true,
    value: "role"
  },
  {
    text: "Telefone",
    align: "center",
    sortable: true,
    value: "phone"
  },
  {
    text: "Email",
    align: "center",
    sortable: true,
    value: "email"
  },
  {
    text: "Ações",
    align: "center",
    sortable: true,
    value: "actions"
  },
]
class Headers {
  static getHeaders() {
    return headers
  }
  static getBudgetHeaders() {
    return budgetHeaders
  }
  static getConsumablesHeaders() {
    return consumablesHeader
  }
  static getEquipamentHeaders() {
    return equipmentsHeaders
  }
  static getUtencilHeaders() {
    return utencilHeaders
  }
  static getUniformsAndEPIsHeaders() {
    return uniformsAndEPIsHeaders
  }
  static getSupervisorHeaders() {
    return supervisorHeaders
  }
}
export default Headers;



// WEBPACK FOOTER //
// ./src/data/headers/InitialContractsHeaders.js